export function mapObjectValues<T>(mappedObject: { [key: string]: T }, mappingFn: (key: string, value: T) => T): { [key: string]: T } {
    return Object.keys(mappedObject).reduce<{ [key: string]: T }>((result, key) => {
        result[key] = mappingFn(key, mappedObject[key]);

        return result;
    }, {});
}
